import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { partnerDetails } from "../../utilities/partnerServices";
import { EinService } from "../../utilities/partnerServices";
import { toast } from "react-toastify";
export const fetchpartnerDetails = createAsyncThunk(
  "users/fetchpartnerDetails",
  partnerDetails
);
export const fetchEinDetails = createAsyncThunk(
  "users/fetchEinDetails",
  EinService
);

const initialState = {
  registerData: {
    displayErrorForEIN: false,
    api: false,
    User_type: "",
    loader: false,
    isPopupOpen: true,
    basicInformation: {
      EIN: {
        value: "",
        isValid: true,
      },
      Email_Address: {
        value: "",
        isValid: true,
      },
      Organization_Name: {
        value: "",
        isValid: true,
      },
      First_Name: {
        value: "",
        isValid: true,
      },
      Last_Name: {
        value: "",
        isValid: true,
      },
      Street_Address: {
        value: "",
        isValid: true,
      },
      password: {
        value: "",
        isValid: true,
      },
      confirmPassword: {
        value: "",
        isValid: true,
      },
    },
    partnerDetails: {
      allowNext: false,
      OrganizationName: "",
      EIN: "",
      zip: "",
      street: "",
      state: "",
      city: "",
      FaxNumber: "",
      PhoneNumber: "",
      partnerDetails: []
    },
    contactInformation: {},
  },
};

const einSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetRegisterdetails: (state) => {
      state.registerData = {
        allowNext: false,
        displayErrorForEIN: false,
        ExtraEinservice: false,
        User_type: "",
        loader: false,
        isPopupOpen: true,
        basicInformation: {
          EIN: {
            value: "",
            isValid: true,
          },
          Email_Address: {
            value: "",
            isValid: true,
          },
          Organization_Name: {
            value: "",
            isValid: true,
          },
          First_Name: {
            value: "",
            isValid: true,
          },
          Last_Name: {
            value: "",
            isValid: true,
          },
          Street_Address: {
            value: "",
            isValid: true,
          },
          password: {
            value: "",
            isValid: true,
          },
          confirmPassword: {
            value: "",
            isValid: true,
          },
        },
        partnerDetails: {
          allowNext: false,
          OrganizationName: "",
          EIN: "",
          zip: "",
          street: [{ key: "", value: "" }],
          state: "",
          city: "",
          PhoneNumber: "",
          FaxNumber: "",
          partnerDetails: []
        },
        contactInformation: {},
      };
    },

    userTypeDetails: (state, action) => {
      state.registerData.User_type = action.payload;
    },
    basicInformationDetails: (state, action) => {
      state.registerData.basicInformation = action.payload;
    },
    contactInformationDetails: (state, action) => {
      state.registerData.contactInformation = action.payload;
    },
    isPopupOpenReducer: (state, action) => {
      state.registerData.isPopupOpen = action.payload;
    },
    updatePartnerFormDetails: (state, action) => {
      state.registerData.partnerDetails = action.payload
    },
    loaderOpen: (state, action) => {
      state.registerData.loader = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchpartnerDetails.pending, (state, action) => {
        state.registerData.loader = true;
      })
      .addCase(fetchpartnerDetails.fulfilled, (state, action) => {
        let data = action.payload;
        if (data?.IntegrationStatusPage?.APIStatusCode == 200) {
          if (data?.source2?.SUBSECTION == "03") {
            let partnerData = state.registerData.partnerDetails;
            partnerData.allowNext = true
            partnerData.OrganizationName = data.source2.NAME;
            partnerData.EIN = data.source2.EIN;
            partnerData.partnerDetails = [{
              address: data.source2.STREET,
              zip: data.source2.ZIP.substring(0, 5),
              state: data.source2.State,
              city: data.source2.City,
              PhoneNumber: "",
              FaxNumber: "",
            }]
            partnerData.PhoneNumber = "";
            partnerData.FaxNumber = "";
            partnerData.street = [
              {
                key: data.source2.STREET,
                value: data.source2.STREET,
              },
            ];
            partnerData.state = data.source2.State;
            partnerData.city = data.source2.City;
            partnerData.zip = data.source2.ZIP.substring(0, 5);
            state.registerData.displayErrorForEIN = false;
          } else {
            toast.error("Community Partner must be an IRS Registered 501c3 Organization")
            state.registerData.partnerDetails.allowNext = false
          }
        } else {
          toast.error(data.IntegrationStatusPage.StatusMessage);
          state.registerData.displayErrorForEIN = true;
        }
        state.registerData.loader = false;
      })
      .addCase(fetchpartnerDetails.rejected, (state, action) => {
        toast.error(action.error.message);
        state.registerData.displayErrorForEIN = true;
        state.registerData.loader = false;
      })
      .addCase(fetchEinDetails.pending, (state, action) => {
        state.registerData.loader = true;
      })
      .addCase(fetchEinDetails.fulfilled, (state, action) => {
        state.registerData.partnerDetails.allowNext = true
      })
      .addCase(fetchEinDetails.rejected, (state, action) => {
        toast.error(action.error.message);
        state.registerData.loader = false;
      })

  },
});
export const {
  basicInformationDetails,
  contactInformationDetails,
  resetRegisterdetails,
  userTypeDetails,
  isPopupOpenReducer,
  updatePartnerFormDetails,
  loaderOpen
} = einSlice.actions;
export default einSlice.reducer;
